import { render } from "./OwnerAddUpdateModal.vue?vue&type=template&id=943e0718"
import script from "./OwnerAddUpdateModal.vue?vue&type=script&lang=js"
export * from "./OwnerAddUpdateModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__